import { useEffect } from 'react';
import { useZoomPan } from '../../hooks/useZoomPan';

interface ImageViewerProps {
  url: string;
  filename: string;
  className?: string;
  onZoomChange?: (zoom: number, zoomIn: () => void, zoomOut: () => void, resetZoom: () => void) => void;
}

export function ImageViewer({ url, filename, className = '', onZoomChange }: ImageViewerProps) {
  const {
    zoom,
    position,
    isDragging,
    isPanMode,
    containerRef,
    contentRef,
    zoomIn,
    zoomOut,
    resetZoom,
    handlers,
  } = useZoomPan({ minZoom: 0.5, maxZoom: 3, zoomStep: 0.25 });

  // Notify parent of zoom state changes
  useEffect(() => {
    onZoomChange?.(zoom, zoomIn, zoomOut, resetZoom);
  }, [zoom, zoomIn, zoomOut, resetZoom, onZoomChange]);

  return (
    <div className={`relative h-full ${className}`}>
      <div
        ref={containerRef}
        className={`h-full w-full overflow-auto flex items-center justify-center bg-gray-100 rounded-lg ${
          zoom > 1 && isPanMode ? (isDragging ? 'cursor-grabbing' : 'cursor-grab') : ''
        }`}
        onMouseDown={handlers.onMouseDown}
        onMouseMove={handlers.onMouseMove}
        onMouseUp={handlers.onMouseUp}
        onMouseLeave={handlers.onMouseLeave}
        onWheel={handlers.onWheel}
      >
        <div
          ref={contentRef}
          className={isDragging ? '' : 'transition-transform duration-150'}
          style={{
            transform: `scale(${zoom}) translate(${position.x / zoom}px, ${position.y / zoom}px)`,
            transformOrigin: 'center center',
          }}
        >
          <img
            src={url}
            alt={filename}
            className="max-w-full h-auto"
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
}
